import { JobProgressionStepStatus } from 'jobs/progression/JobProgression'
import { isEmpty, isNil } from 'lodash'

export enum JobProgressionStepFilterOption {
  None,
  NotStarted,
  JobStarted,
  OpenItems,
  DraftInReview,
  DraftRejected,
  DraftApproved,
  AuthorizationRequested,
  AuthorizationSigned,
  ReturnFiled,
  PreparationCompleted,
  ReviewCompleted,
  ExtensionInProgress,
  ExtensionConfirmed,
  ExtensionAccepted,
  ExtensionRejected,
  WaitingOnClient,
  ReadyToFile,
}

export function matchesProgressionStepFilter(
  progressionStepStatus: JobProgressionStepStatus,
  progressionStepStatusFilters?: JobProgressionStepFilterOption[],
) {
  if (
    isNil(progressionStepStatusFilters) ||
    isEmpty(progressionStepStatusFilters)
  ) {
    return true
  }

  return progressionStepStatusFilters.some((filter) =>
    isJobProgressionStepMatch(progressionStepStatus, filter),
  )
}

function isJobProgressionStepMatch(
  progressionStepStatus: JobProgressionStepStatus,
  progressionStepStatusFilter: JobProgressionStepFilterOption,
): boolean {
  switch (progressionStepStatusFilter) {
    case JobProgressionStepFilterOption.None:
      return (
        progressionStepStatus ===
        JobProgressionStepStatus.PROGRESSION_STEP_UNSPECIFIED
      )
    case JobProgressionStepFilterOption.NotStarted:
      return progressionStepStatus === JobProgressionStepStatus.NOT_STARTED
    case JobProgressionStepFilterOption.OpenItems:
      return progressionStepStatus === JobProgressionStepStatus.OPEN_ITEMS
    case JobProgressionStepFilterOption.JobStarted:
      return progressionStepStatus === JobProgressionStepStatus.JOB_STARTED
    case JobProgressionStepFilterOption.DraftInReview:
      return progressionStepStatus === JobProgressionStepStatus.DRAFT_IN_REVIEW
    case JobProgressionStepFilterOption.DraftApproved:
      return progressionStepStatus === JobProgressionStepStatus.DRAFT_APPROVED
    case JobProgressionStepFilterOption.DraftRejected:
      return progressionStepStatus === JobProgressionStepStatus.DRAFT_REJECTED
    case JobProgressionStepFilterOption.AuthorizationRequested:
      return (
        progressionStepStatus ===
        JobProgressionStepStatus.AUTHORIZATION_REQUESTED
      )
    case JobProgressionStepFilterOption.AuthorizationSigned:
      return (
        progressionStepStatus === JobProgressionStepStatus.AUTHORIZATION_SIGNED
      )
    case JobProgressionStepFilterOption.ReturnFiled:
      return progressionStepStatus === JobProgressionStepStatus.RETURN_FILED
    case JobProgressionStepFilterOption.PreparationCompleted:
      return (
        progressionStepStatus === JobProgressionStepStatus.PREPARATION_COMPLETED
      )
    case JobProgressionStepFilterOption.ReviewCompleted:
      return progressionStepStatus === JobProgressionStepStatus.REVIEW_COMPLETED
    case JobProgressionStepFilterOption.ExtensionInProgress:
      return (
        progressionStepStatus === JobProgressionStepStatus.EXTENSION_IN_PROGRESS
      )
    case JobProgressionStepFilterOption.ExtensionConfirmed:
      return (
        progressionStepStatus === JobProgressionStepStatus.EXTENSION_CONFIRMED
      )
    case JobProgressionStepFilterOption.ExtensionAccepted:
      return (
        progressionStepStatus === JobProgressionStepStatus.EXTENSION_ACCEPTED
      )
    case JobProgressionStepFilterOption.ExtensionRejected:
      return (
        progressionStepStatus === JobProgressionStepStatus.EXTENSION_REJECTED
      )
    case JobProgressionStepFilterOption.WaitingOnClient:
      return (
        progressionStepStatus ===
        JobProgressionStepStatus.PROGRESSION_WAITING_ON_CLIENT
      )
    case JobProgressionStepFilterOption.ReadyToFile:
      return progressionStepStatus === JobProgressionStepStatus.READY_TO_FILE
    default:
      return false
  }
}
